import axios from 'axios';
import { config } from '@/helpers';
export { axios };
export const campaignUrl = () => config('BACKEND_ROOT') + '/admin/campaigns';
export const promotionUrl = () => config('BACKEND_ROOT') + '/admin/promotions';
export function errorsFrom(error) {
  const body = error.response && error.response.data;
  return body && body.errors
    ? Object.values(body.errors).flat()
    : [(body && body.message) || 'Unable to complete the request. Please try again.'];
}
export const defaults = () => ({
  promotion_code_id: null,
  title: '',
  description: '',
  link: '',
  enabled: false,
  show_banner: true,
  show_popup: true,
  popup_delay_seconds: 5,
  priority: 1,
});
export function payload(form) {
  return Object.keys(defaults()).reduce((result, key) => {
    result[key] =
      key === 'link'
        ? form[key].trim() || null
        : key === 'title'
        ? form[key].trim()
        : form[key];
    return result;
  }, {});
}
export function validLink(link) {
  return !link || /^\/(?!\/)[^\\\s]*$/.test(link);
}
